package id.neotica.neotica.components

import com.varabyte.kobweb.compose.ui.graphics.Color

object NeoColor {
    val white = Color.rgb(0xF0, 0xF8, 0xFF)
    val transparent = Color.rgba(0x0, 0x0, 0x0, 0x0)
    val colorPrimary = Color.rgb(93, 110, 224)
    val colorPrimary20 = Color.rgba(93, 110, 224, 50)
    val backgroundPrimary = Color.rgb(20, 0, 71)
    val backgroundPrimaryTransparent = Color.rgba(0x10, 0x10, 0x30, 0x90)

    val negativePrimary = Color.rgb(225, 0, 0)
}